// extracted by mini-css-extract-plugin
export var amount = "styles-module--amount--fb85f";
export var button = "styles-module--button--6ca08";
export var container = "styles-module--container--2d950";
export var content = "styles-module--content--b01f0";
export var description = "styles-module--description--69f6f";
export var firstTitle = "styles-module--firstTitle--8596d";
export var freebet = "styles-module--freebet--72728";
export var image = "styles-module--image--faef4";
export var imageMobile = "styles-module--imageMobile--6fc7a";
export var images = "styles-module--images--15434";
export var ru = "styles-module--ru--74025";
export var rulesLink = "styles-module--rulesLink--6fb0d";
export var secondTitle = "styles-module--secondTitle--e7d56";
export var text = "styles-module--text--d81f8";
export var title = "styles-module--title--86228";